import { render, staticRenderFns } from "./ComboboxTemas.vue?vue&type=template&id=01fe5db8&"
import script from "./ComboboxTemas.vue?vue&type=script&lang=js&"
export * from "./ComboboxTemas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports